import { BrandEntity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandUpdateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandUpdateResponseDTO.validationSchema(),
    BrandEntity
  );

  constructor(readonly data: RoomBrandUpdateResponse) {
    JsonSchemaValidator.assert(RoomBrandUpdateResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["brand"],
      properties: {
        brand: {
          instanceof: BrandEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandUpdateResponse {
  brand: BrandEntity;
}
